import { FINANCIALS_ACTIONS } from "constants/actions";

export function fetchFinancialYears(companyId) {
    return {
        type: FINANCIALS_ACTIONS.FETCH_FINANCIAL_YEARS,
        payload: {
            companyId
        }
    };
}

export function fetchedFinancialYears(companyId, financialYearRecords) {
    return {
        type: FINANCIALS_ACTIONS.FETCHED_FINANCIAL_YEARS,
        payload: {
            companyId,
            financialYearRecords
        }
    };
}

export function failedFetchFinancialYears(companyId, error) {
    return {
        type: FINANCIALS_ACTIONS.FAILED_FETCH_FINANCIAL_YEARS,
        payload: {
            companyId
        },
        error
    };
}

export function createFinancialYear(companyId, yearName) {
    return {
        type: FINANCIALS_ACTIONS.CREATE_FINANCIAL_YEAR,
        payload: {
            companyId,
            yearName
        }
    };
}
export function createdFinancialYear(companyId, yearName, yearRecord) {
    return {
        type: FINANCIALS_ACTIONS.CREATED_FINANCIAL_YEAR,
        payload: {
            companyId,
            yearName,
            yearRecord
        }
    };
}
export function failedCreateFinancialYear(companyId, yearName, error) {
    return {
        type: FINANCIALS_ACTIONS.FAILED_CREATE_FINANCIAL_YEAR,
        payload: {
            companyId,
            yearName
        },
        error
    };
}

export function fetchFinancials(companyId) {
    return {
        type: FINANCIALS_ACTIONS.FETCH_FINANCIALS,
        payload: {
            companyId
        }
    };
}

export function fetchedFinancials(companyId, financialRecords) {
    return {
        type: FINANCIALS_ACTIONS.FETCHED_FINANCIALS,
        payload: {
            companyId,
            financialRecords
        }
    };
}

export function failedFetchFinancials(companyId, error) {
    return {
        type: FINANCIALS_ACTIONS.FAILED_FETCH_FINANCIALS,
        payload: {
            companyId,
            error
        }
    };
}

export function updateFinancials(companyId, financialRecords) {
    return {
        type: FINANCIALS_ACTIONS.UPDATE_FINANCIALS,
        payload: {
            companyId,
            financialRecords
        }
    };
}

export function updatedFinancials(companyId, financialRecords) {
    return {
        type: FINANCIALS_ACTIONS.UPDATED_FINANCIALS,
        payload: {
            companyId,
            financialRecords
        }
    };
}

export function failedUpdateFinancials(companyId, error) {
    return {
        type: FINANCIALS_ACTIONS.FAILED_UPDATE_FINANCIALS,
        payload: {
            companyId
        },
        error
    };
}
